export class IdName {
  public id: number;
  public name: string;

  constructor(init?: any) {
    Object.assign(this, init);
  }
}
